// Navigation
export function mainNavigation() {
  const menuToggle = document.getElementById('menu-toggle');
  const siteNavigation = document.querySelector('.primary-nav-menu');
  const dropdownParent = document.querySelectorAll('.nav-menu-item-has-children');
  const dropdownTarget = document.querySelectorAll('.nav-menu-item-has-children > a');
  const subMenus = document.getElementsByClassName('sub-menu');
  const breakPoint = 800;

  const screenReaderText = {
    "expand": "Expand Sub Menu",
    "collapse": "Collapse Sub Menu"
  };

  // Add mobile dropdown toggles
  if (window.innerWidth < breakPoint) {
    for (let i = 0; i < dropdownTarget.length; i++) {
      // Create mobile dropdown toggle
      let ddBtn = document.createElement('button');
      ddBtn.type = 'button';
      ddBtn.className = 'dropdown-toggle';
      ddBtn.setAttribute('aria-expanded', false)
      let btnSpan = document.createElement('span');
      btnSpan.className = 'sr-only';
      btnSpan.innerHTML = screenReaderText.expand;
      ddBtn.append(btnSpan);
      dropdownTarget[i].after(ddBtn);

      // Button clicked to expand subnav
      ddBtn.addEventListener('click', function () {
        // Toggle aria-expanded on button
        const smBtnOpen = JSON.parse(ddBtn.getAttribute('aria-expanded'));
        ddBtn.setAttribute('aria-expanded', !smBtnOpen);
        ddBtn.classList.toggle('toggled-on');
        // Toggle sr-only button text
        if (btnSpan.innerHTML == screenReaderText.expand) {
          btnSpan.innerHTML = screenReaderText.collapse
        } else {
          btnSpan.innerHTML = screenReaderText.expand
        }
        // Toggle toggled-on class to sub-menu
        let subMenu = ddBtn.nextElementSibling;
        subMenu.classList.toggle('toggled-on');
      })
    }
    for (let i = 0; i < dropdownParent.length; i++) {
      dropdownParent[i].setAttribute('aria-haspopup', true);
    }

    // Mobile menu
    siteNavigation.setAttribute('aria-expanded', false);

    // Mobile nav button clicked to expand nav
    menuToggle.addEventListener('click', function () {
      // Toggle aria-expanded on button
      const open = JSON.parse(menuToggle.getAttribute('aria-expanded'));
      menuToggle.setAttribute('aria-expanded', !open);
      menuToggle.classList.toggle('toggled-on');

      // Toggle scrolling on body
      document.body.classList.toggle('modal-visible');

      // Open/close nav menu
      siteNavigation.classList.toggle('toggled-on');
      // Toggle aria-expanded on nav menu
      const openNav = JSON.parse(siteNavigation.getAttribute('aria-expanded'));
      siteNavigation.setAttribute('aria-expanded', !openNav);

      // Close all submenus if main nav is closed
      if (siteNavigation.classList.contains('toggled-on') === false) {
        for (const sm of subMenus) {
          sm.classList.remove('toggled-on');
          let prevBtn = sm.previousElementSibling;
          prevBtn.classList.remove('toggled-on');
        }
      }
    });
  }

  else {
    // Toggle aria-expanded on parent a elements
    for (let i = 0; i < dropdownParent.length; i++) {
      dropdownTarget[i].setAttribute('aria-expanded', false);
      dropdownParent[i].addEventListener('mouseover', function() {
        dropdownTarget[i].setAttribute('aria-expanded', true);
      })
      dropdownParent[i].addEventListener('mouseout', function() {
        dropdownTarget[i].setAttribute('aria-expanded', false);
      })
    }
  }
}